export interface Game {
    id: number,
    name: string,
    icon: string,
    contextId: number,
    inventoryLimit: number,
    orderItemsLimit?: number,
    alias: string,
    isNew: boolean,
    isActive: boolean,
    sortOrder: number,
    offlineBidsEnabled: boolean,
    offlineBidsActivatePercent?: number,
    offlineBidsDeactivatePercent?: number
}

/** Способ загрузки (синхронизации) инвентаря пользователя */
export enum InventorySyncType {
    /** Через авторизованного бота (по торговой ссылке пользователя) */
    Bot = 0,
    /** Через внешний сервис steamapis.com */
    SteamApis = 1,
    /** По публичной ссылке на инвентарь */
    PublicLink = 2
}

export const InventorySyncTypeDescription = {
    0: 'Через бота',
    1: 'SteamApis',
    2: 'По публичной ссылке',
}

/** Настройка способа загрузки инвентаря игры */
export interface GameInventorySetting {
    syncType: InventorySyncType,
    enabled: boolean,
    sortOrder: number
    updated?: Date
}

/** Настройка способа загрузки инвентаря игры для обновления */
export interface UpdateGameInventorySettingItem {
    syncType: InventorySyncType,
    enabled: boolean,
    sortOrder: number
}